import { Directive, ElementRef, HostListener, Input } from '@angular/core';

@Directive({
  selector: '[restrictToNumbers]',
  standalone:true,
})
export class RestrictToNumbersDirective {
  @Input() maxDigits: number = Infinity; // Allow unlimited digits by default

  constructor(private el: ElementRef) {}

  @HostListener('input', ['$event']) onInput(event: Event): void {
    const inputElement = this.el.nativeElement as HTMLInputElement;
    let value = inputElement.value;

    // Remove non-numeric characters
    value = value.replace(/[^0-9]/g, '');

    // Truncate to maxDigits
    if(this.maxDigits){
      if (value.length > this.maxDigits) {
        value = value.slice(0, this.maxDigits);
      }
    }

    // Update the input field value
    inputElement.value = value;
  }
}